import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { DocumentOrFolderOrigin } from '../enums/documentOrFolderOrigin'
import { fetchFolders } from '../query-api'
import { DmsFolderNode } from '../types'
import { useDmsUserRole } from './useDmsUserRole'

export const useHasMigratedFolders = () => {
  const { organization } = useUserOrganization()
  const { isBoWithoutCpa, isCpaExpertMode, isLoading: isRoleLoading } = useDmsUserRole()
  const isCpa = isBoWithoutCpa || isCpaExpertMode

  const { data: hasMigratedFolders, isLoading } = useQuery<DmsFolderNode[], Error, boolean>(
    [QueryKeys.DmsFolders, organization?.id, isCpa],
    () => fetchFolders(organization?.id as string, isCpa),
    {
      enabled: !!organization?.id && !isRoleLoading,
      staleTime: defaultStaleTime,
      select: (folders) => folders.some((folder) => folder.origin === DocumentOrFolderOrigin.MIGRATION),
    },
  )

  return {
    hasMigratedFolders: hasMigratedFolders ?? false,
    isLoading,
  }
}
